module.exports = __webpack_public_path__ + "img/modulo_Leads.6bd68bb.svg";